import { FiatProviderDetails, FiatProviderDetailsAdapter } from "./fiat-provider-details.model";
import { PaymentOptionDto } from "@modules/+new/payments/features/payment-options/infrastructure/dto/payment-option.dto";
import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";

export interface PaymentOption {
	readonly id: number;
	readonly description: string;
	readonly enabled: boolean;
	fiatProviderDetails: FiatProviderDetails[];
	readonly footnote: string;
	readonly isInstant: boolean;
	readonly isLogoDescriptive: boolean;
	readonly isVoucher: boolean;
	readonly logo: string; // TODO to Logo object
	readonly logoDark: string;
	readonly name: string;
	readonly savingsEnabled: boolean; // TODO what is difference between 'savings_enabled' in 'FiatProviderDetails'?
	readonly shortName: string;
	readonly sort: number;
	readonly terms: string;
	readonly unavailable: boolean;
	readonly summaryNotification: string;
}

export class PaymentOptionAdapter extends BaseAdapter<PaymentOptionDto, PaymentOption> {
	private fiatProviderDetailsAdapter: FiatProviderDetailsAdapter = new FiatProviderDetailsAdapter();
	public constructor() {
		super();
	}

	public adapt(item: PaymentOptionDto): PaymentOption {
		if (!item) {
			return null;
		}

		return {
			id: Number(item.id),
			description: item.description,
			enabled: item.enabled,
			fiatProviderDetails: this.fiatProviderDetailsAdapter.adaptMany(item.fiat_provider_details),
			footnote: item.footnote,
			isInstant: item.is_instant,
			isLogoDescriptive: item.is_logo_descriptive,
			isVoucher: item.is_voucher,
			logo: item.logo,
			logoDark: item.logo_dark,
			name: item.name,
			savingsEnabled: item.savings_enabled, // TODO what is difference between 'savings_enabled' in 'FiatProviderDetails'?
			shortName: item.short_name,
			sort: item.sort,
			terms: item.terms,
			unavailable: item.unavailable,
			summaryNotification: item.summary_notification
		};
	}
}
